import { render, staticRenderFns } from "./HcmLanguageSwitch.vue?vue&type=template&id=2a709aa1&scoped=true"
import script from "./HcmLanguageSwitch.js?vue&type=script&lang=js&external"
export * from "./HcmLanguageSwitch.js?vue&type=script&lang=js&external"
import style0 from "./HcmLanguageSwitch.scss?vue&type=style&index=0&id=2a709aa1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a709aa1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotHcmDropdownHeader: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmDropdown/HcmDropdownHeader.vue').default,HotHcmIcon: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmIcon/HcmIcon.vue').default,HotHcmDropdownItem: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmDropdown/HcmDropdownItem.vue').default,HotHcmDropdown: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmDropdown/HcmDropdown.vue').default})
